import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Listings from "@/pages/Listings";
import MapView from "@/pages/MapView";
import PropertyDetail from "@/pages/PropertyDetail";
import ListProperty from "@/pages/ListProperty";
import Favourites from "@/pages/Favourites";
import LocationPage from "@/pages/LocationPage";
import Guides from "@/pages/Guides";
import GuideArticle from "@/pages/GuideArticle";
import AgentDashboard from "@/pages/AgentDashboard";
import CategoryLocationPage from "@/pages/CategoryLocationPage";
import Legal from "@/pages/Legal";
import Premium from "@/pages/Premium";
import ContactAbout from "@/pages/ContactAbout";
import AdminDashboard from "@/pages/AdminDashboard";

function Layout() {
  const location = useLocation();
  const isMap = location.pathname === "/map";
  return (
    <>
      <Header />
      <main className="min-h-[60vh]">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/properties" element={<Listings />} />
          <Route path="/properties/:category/:location" element={<CategoryLocationPage />} />
          <Route path="/agricultural-land" element={<Listings landing="agricultural-land" />} />
          <Route path="/plots" element={<Listings landing="plots" />} />
          <Route path="/homes" element={<Listings landing="homes" />} />
          <Route path="/commercial" element={<Listings landing="commercial" />} />
          <Route path="/hyderabad" element={<Navigate to="/location/hyderabad" replace />} />
          <Route path="/kadthal" element={<Navigate to="/location/kadthal" replace />} />
          <Route path="/shadnagar" element={<Navigate to="/location/shadnagar" replace />} />
          <Route path="/location/:slug" element={<LocationPage />} />
          <Route path="/guides" element={<Guides />} />
          <Route path="/guides/:slug" element={<GuideArticle />} />
          <Route path="/privacy" element={<Legal doc="privacy" />} />
          <Route path="/terms" element={<Legal doc="terms" />} />
          <Route path="/listing-policy" element={<Legal doc="listing-policy" />} />
          <Route path="/disclaimer" element={<Legal doc="disclaimer" />} />
          <Route path="/map" element={<MapView />} />
          <Route path="/property/:id" element={<PropertyDetail />} />
          <Route path="/list-property" element={<ListProperty />} />
          <Route path="/favourites" element={<Favourites />} />
          <Route path="/agent" element={<AgentDashboard />} />
          <Route path="/premium" element={<Premium />} />
          <Route path="/contact" element={<ContactAbout />} />
          <Route path="/about" element={<ContactAbout />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </main>
      {!isMap && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Layout />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
